/**
 * Hero. Porte de `bicicletas_peniel_prototipo.html` linhas 90-112.
 *
 * MUDANÇA DELIBERADA: o protótipo punha a foto em `background-image` (a classe
 * `.hero-bg`). Aqui ela é um `<img>` de verdade, porque o preload scanner do
 * navegador NÃO enxerga imagem de CSS — e como esta é o LCP da home, o
 * background criaria uma cascata HTML → CSS → imagem. Com `<img>` +
 * `fetchPriority="high"` o download começa junto com o HTML.
 *
 * O overlay escuro virou um div irmão com a utility `hero-overlay`.
 */
import { Link } from 'react-router-dom'

import { useConfigLoja } from '@/shared/hooks/useConfigLoja.js'

/** Foto embarcada: garante hero preenchido mesmo antes de `/api/configuracoes`. */
/**
 * URL ESTÁVEL, resolvida pelo backend (ver `rotas/publicas/hero.ts`).
 *
 * Precisa ser idêntica à do `<link rel="preload">` no index.html — URL
 * diferente faria o navegador baixar a imagem duas vezes. Por isso não se
 * monta mais o src a partir de `config.heroImagem` aqui: a configuração só
 * chega depois do JavaScript, e era exatamente essa espera que o preload
 * existe para eliminar.
 */
const HERO = '/api/hero.webp'

export function Hero() {
  const config = useConfigLoja()

  return (
    <section id="inicio" className="relative flex h-[80vh] items-center overflow-hidden">
      <img
        src={HERO}
        alt=""
        aria-hidden
        fetchPriority="high"
        decoding="async"
        className="absolute inset-0 size-full object-cover"
      />
      <div className="hero-overlay absolute inset-0" aria-hidden />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 text-center sm:px-6 md:text-left lg:px-8">
        <div className="md:w-2/3 lg:w-1/2">
          <span className="mb-4 inline-block rounded-full border border-brand-500/30 bg-brand-500/20 px-3 py-1 text-sm font-semibold text-brand-100 backdrop-blur-sm">
            {config.heroSelo}
          </span>

          <h1 className="mb-6 text-4xl font-bold leading-tight text-white md:text-5xl lg:text-6xl">
            {/* O protótipo quebrava a linha e pintava "duas rodas" de verde. */}
            {config.heroTitulo.replace(config.heroTituloDestaque, '').trim()}{' '}
            <br />
            <span className="text-brand-500">{config.heroTituloDestaque}</span>
          </h1>

          <p className="mx-auto mb-8 max-w-lg text-lg text-gray-200 md:mx-0">
            {config.heroSubtitulo}
          </p>

          <div className="flex flex-col justify-center gap-4 sm:flex-row md:justify-start">
            <Link
              to="/bicicletas?condicao=NOVA"
              className="inline-flex min-h-12 items-center justify-center rounded-full bg-brand-700 px-8 font-bold text-white shadow-lg transition hover:bg-brand-800 hover:shadow-xl"
            >
              Ver Bikes Novas
            </Link>
            <Link
              to="/bicicletas?condicao=USADA"
              className="inline-flex min-h-12 items-center justify-center rounded-full bg-white px-8 font-bold text-gray-900 shadow-lg transition hover:bg-gray-100 hover:shadow-xl"
            >
              Ver Bikes Usadas
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
